module.exports = __webpack_public_path__ + "static/media/hibiki.dab9e620.png";